import { useUserId } from '@/features/account/services/User/hooks'
import { useUserShoppingStore } from '@/features/shop/services/ShoppingStore/hooks'
import { routes, getRetailerUrl } from '@shared/constants/routes'

/**
 * Returns the appropriate home URL depending on if the user is logged in or not.
 */
export const useHomeUrl = () => {
  const userId = useUserId()
  const { data: shoppingStore } = useUserShoppingStore()

  return userId ? getRetailerUrl(shoppingStore?.name) : routes.UNGATED_HOMEPAGE.url
}
